import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";
import { cn } from "@/lib/utils";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

export function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      classNames={{
        month_caption: "flex justify-center items-center relative mb-3 h-7",
        caption_label: "text-[13px] font-semibold text-foreground",
        nav: "flex items-center gap-1",
        button_previous:
          "absolute left-0 h-7 w-7 flex items-center justify-center rounded-[6px] text-muted-foreground hover:text-foreground hover:bg-[var(--surface-muted)] transition-colors cursor-pointer",
        button_next:
          "absolute right-0 h-7 w-7 flex items-center justify-center rounded-[6px] text-muted-foreground hover:text-foreground hover:bg-[var(--surface-muted)] transition-colors cursor-pointer",
        month_grid: "w-full border-collapse",
        weekdays: "flex mb-1",
        weekday:
          "text-muted-foreground w-8 text-[11px] font-medium text-center",
        week: "flex w-full mt-1",
        day: "relative p-0 text-center",
        day_button:
          "h-8 w-8 text-[13px] rounded-[6px] hover:bg-[var(--surface-muted)] hover:text-foreground transition-colors cursor-pointer focus:outline-none focus:ring-1 focus:ring-border",
        selected:
          "!bg-foreground !text-[var(--page-bg)] hover:!bg-foreground hover:!text-[var(--page-bg)] rounded-[6px]",
        today:
          "bg-[var(--surface-muted)] text-foreground font-semibold rounded-[6px]",
        outside: "text-muted-foreground opacity-30",
        disabled: "text-muted-foreground opacity-25 cursor-not-allowed",
        hidden: "invisible",
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation }) =>
          orientation === "left" ? (
            <ChevronLeft className="h-3.5 w-3.5" />
          ) : (
            <ChevronRight className="h-3.5 w-3.5" />
          ),
      }}
      {...props}
    />
  );
}
